// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"95fb1b13","453":"98466d00","666":"bbd00e46"}[chunkId] + ".chunk.js";
};